'use client';
import React, { useEffect, useRef, useState } from 'react';

interface SkillItem {
  id?: number | string;
  name: string;
  image: string;
  width: number;
  height: number;
  className: string;
  class_name?: string;
}

function SkillSkeleton() {
  return (
    <div className="bg-transparent border-t border-t-gray-400 shadow-lg rounded-3xl p-4 sm:p-6 lg:p-8 lg:mt-20 flex flex-col items-center md:items-start md:flex-row gap-4 md:gap-10 justify-around">
      <div className="flex flex-wrap gap-4 items-center justify-center">
        {Array.from({ length: 12 }).map((_, i) => (
          <div
            key={i}
            className="w-16 h-16 md:w-24 md:h-24 rounded-lg bg-gray-200 animate-pulse"
          />
        ))}
      </div>
    </div>
  );
}

export default function SkillSection() {
  const sectionRef = useRef<HTMLDivElement>(null);
  const [skills, setSkills] = useState<SkillItem[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch('/api/skills')
      .then((res) => res.json())
      .then((data) => {
        if (data?.skills) {
          const mapped = data.skills.map((s: SkillItem) => ({
            ...s,
            className: s.class_name || s.className || 'mx-auto mb-4 w-16 md:w-24 rounded-lg',
          }));
          setSkills(mapped);
        }
      })
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('aos-animate');
          }
        });
      },
      { threshold: 0.1 }
    );

    if (sectionRef?.current) {
      observer?.observe(sectionRef?.current);
    }

    return () => observer?.disconnect();
  }, []);

  return (
    <section
      id="skill"
      className="p-4 sm:p-6 lg:p-8 text-[#48438e] text-shadow-sm"
    >
      <div
        ref={sectionRef}
        className="mt-24 space-y-8 fade-in-section"
      >
        <div className="flex flex-col gap-1 items-center">
          <h2 className="text-4xl">Skill &amp; Tools</h2>
          <p className="text-lg">Berikut Beberapa Aplikasi/Bahasa Pemograman Yang Saya Pernah Gunakan</p>
        </div>

        {loading ? (
          <SkillSkeleton />
        ) : (
          <div className="bg-transparent border-t border-t-gray-400 shadow-lg rounded-3xl p-4 sm:p-6 lg:p-8 lg:mt-20 flex flex-col items-center md:items-start md:flex-row gap-4 md:gap-10 justify-around">
            <div>
              <div className="flex flex-wrap gap-4 items-center justify-center">
                {skills?.map((skill) => (
                  <div
                    key={skill?.id || skill?.name}
                    className="transform transition duration-500 hover:scale-110"
                  >
                    <img
                      alt={skill?.name}
                      loading="lazy"
                      width={skill?.width}
                      height={skill?.height}
                      className={skill?.className}
                      src={skill?.image}
                    />
                  </div>
                ))}
              </div>
            </div>
          </div>
        )}
      </div>
    </section>
  );
}
